import { Column, Entity, Index, OneToMany } from 'typeorm';
import { AlertBannerMapEntity } from './alert-banner-map.entity';
import { BaseEntity } from './base.entity';

@Index('_alert_banner_fetch_ix', ['startDate', 'endDate', 'isPublic'], {})
@Entity('_alert_banner')
export class AlertBannerEntity extends BaseEntity {
	@Column('varchar', { name: '_name', length: 100 })
	public name!: string;

	@Column('longtext', { name: '_title' })
	public title!: string;

	@Column('longtext', { name: '_detail', nullable: true })
	public detail!: string | null;

	@Column('varchar', { name: '_color', length: 32 })
	public color!: string;

	@Column('varchar', { name: '_icon', length: 32 })
	public icon!: string;

	@Column('datetime', { name: '_startDate', nullable: true })
	public startDate!: Date | null;

	@Column('datetime', { name: '_endDate', nullable: true })
	public endDate!: Date | null;

	@Column('tinyint', { name: '_isDismissable', width: 1 })
	public isDismissable!: boolean;

	@Column('tinyint', { name: '_isPublic', width: 1 })
	public isPublic!: boolean;

	@OneToMany(
		() => AlertBannerMapEntity,
		(alertBannerMap) => alertBannerMap.fkAlertBanner,
	)
	public alertBannerMaps!: Array<AlertBannerMapEntity>;
}
